<template>
    <div class="bg-gray-900 p-12 px-8 text-center lg:px-16">
        <div class="mx-auto max-w-4xl">
            <h1
                class="text-[28px] font-semibold leading-snug text-white antialiased lg:text-[40px]"
            >
                Over the last decade we’ve helped
                <br class="hidden md:inline-block" />
                <span class="handwritten-underline-sm">200K+</span> students
                pass their <span class="text-[.95em]">NREMT</span> exam
            </h1>

            <div class="mt-6 leading-loose text-white">
                EMTprep was founded in Austin, TX in 2008 by two paramedics who
                were frustrated with the lack of online study materials for the
                NREMT. They set out to build the web’s best online program for
                NREMT test-prep in order to help students through this tricky
                exam. Fast forward two decades later, and they’ve helped
                hundreds of thousands of students prepare for and pass their
                NREMT.
            </div>
        </div>
    </div>
    <div class="container mx-auto mb-24 max-w-5xl">
        <div class="my-12 text-center text-[36px] font-bold">Contact Us</div>
        <div class="flex flex-col justify-center gap-12 lg:flex-row">
            <div class="lg:w-[440px]">
                <div class="text-[20px] font-bold">For students</div>
                <div class="mb-4 mt-4 leading-loose">
                    If you have a question, take a look at our
                    <Link class="link" :href="route('frontend.faqs')"
                        >FAQs.
                    </Link>
                    For additional questions or comments, send us an email and
                    we’ll respond within 24 hours.
                </div>
                <copy-to-clipboard-button copied-text="info@emtprep.com" />
            </div>
            <div class="hidden w-[1px] border-r lg:block"></div>
            <div class="lg:w-[440px]">
                <div class="text-[20px] font-bold">
                    For instructors and employers
                </div>
                <div class="mb-4 mt-4 leading-loose">
                    Find out how you can bring EMTprep to your classroom. Visit
                    the
                    <Link class="link" :href="route('frontend.groups')"
                        >bulk memberships
                    </Link>
                    page for more information, or contact us with any questions.
                </div>
                <copy-to-clipboard-button copied-text="groups@emtprep.com" />
            </div>
        </div>
    </div>

    <div class="bg-gray-50 p-6 py-24">
        <div class="mb-16 text-center text-[36px] font-bold">
            Leadership Team
        </div>

        <div class="flex flex-wrap justify-center gap-8 lg:container">
            <div class="w-[300px] flex-none">
                <div class="">
                    <img
                        class="h-auto w-full"
                        src="/assets/art/profiles/profile_stevewilliams.jpg"
                    />
                </div>
                <div class="font-semibold">Stephen G. Williams, M.ED EMT-P</div>
                <div class="text-[16px] text-gray-600">Co-Founder</div>
                <div class="mt-4 text-[16px] leading-loose">
                    <read-more-text-block
                        text="Steve holds a Master’s in Education from Western Oregon
                    University with an emphasis in information technology. He is
                    one of the first to graduate from their school of education
                    with a certificate in Instructional Design. During his
                    studies, Steve focused heavily on finding new ways to
                    incorporate technology into education. Steve graduated from
                    the Paramedic Program at Oregon Health & Science University
                    and is now a career Firefighter/Paramedic in Oregon’s
                    Willamette Valley."
                        :preview-lines="3"
                    />
                </div>
            </div>
            <div class="w-[300px] flex-none">
                <div class="">
                    <img
                        class="h-auto w-full"
                        src="/assets/art/profiles/profile_bryangassner.jpg"
                    />
                </div>
                <div class="font-semibold">Bryan Gassner, BS, EMT-P</div>
                <div class="text-[16px] text-gray-600">Co-Founder</div>
                <div class="mt-4 text-[16px] leading-loose">
                    <read-more-text-block
                        text="Bryan has been involved in EMS since 2002 and graduated from
                    the Paramedic Program at Oregon Health & Science University.
                    He went on to obtain a Bachelor’s degree from the University
                    of Oregon, specializing in Exercise Physiology. His passion
                    has been combining technology and education, exploring ways
                    to bridge the gaps in the traditional teaching methods. He
                    currently works as a Lieutenant/Paramedic in Portland, OR."
                        :preview-lines="3"
                    />
                </div>
            </div>
            <div class="w-[300px] flex-none">
                <div class="">
                    <img
                        class="h-auto w-full"
                        src="/assets/art/profiles/profile_ramseyselbak.jpg"
                    />
                </div>
                <div class="font-semibold">Ramsey Selbak, MD</div>
                <div class="text-[16px] text-gray-600">Physician Advisor</div>
                <div class="mt-4 text-[16px] leading-loose">
                    <read-more-text-block
                        text="Dr. Selbak completed his undergrad at Portland State
                    University and then graduated with a Doctorate of Medicine
                    from Oregon Health & Science University (OHSU). Dr. Selbak
                    completed his residency at OHSU as well, serving as chief
                    resident in his final year of residency. Dr. Selbak
                    currently works as an Instructor of Emergency Medicine at
                    OHSU’s School of Medicine. Dr. Selbak is currently
                    completing a Clinical Ultrasound Fellowship and is actively
                    seeking ways to integrate that technology into EMS."
                        :preview-lines="3"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FrontendLayout from "@/_Layouts/FrontendLayout";
import CopyToClipboardButton from "@/Components/CopyToClipboardButton";
import ReadMoreTextBlock from "@/Pages/Frontend/ReadMoreTextBlock";

export default {
    name: "AboutUs",
    components: { ReadMoreTextBlock, CopyToClipboardButton },
    layout: FrontendLayout,
};
</script>
